export const FEATURES_CATEGORIES = [
  {
    title: 'Comfort & Convenience',
    titleCategory: 'Comfort & Convenience',
    featureCategory: 'comfort_convenience',
    icon: 'icon-audio_steering_wheel_control',
  },
  {
    title: 'Entertainment',
    titleCategory: 'In Car Entertainment',
    featureCategory: 'entertainment',
    icon: 'icon-mobile_internet',
  },
  {
    title: 'Safety',
    titleCategory: 'Safety',
    featureCategory: 'safety',
    icon: 'icon-shield-check',
  },
];

export const INSTALLED_UPGRADES = 'Installed Upgrades';
export const FEATURES = 'Features';
export const CREATIVE_ID = 'features-modal';
